import { Component, Inject, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { NebenkostenArtikelDialogComponent } from './nebenkosten-artikel-dialog/nebenkosten-artikel-dialog.component';
import { NebenkostenArtikelTagsDialogComponent } from './nebenkosten-artikel-tags-dialog/nebenkosten-artikel-tags-dialog.component';

@Component({
    selector: 'kiene-nebenkosten-artikel',
    templateUrl: './nebenkosten-artikel.component.html',
    styleUrls: ['./nebenkosten-artikel.component.scss'],
})
export class NebenkostenArtikelComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private router: Router,
        private dialog: MatDialog,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Nebenkosten-Artikel';
        this.tableDescriptor.uniqueIdentifier = 'NebenkostenArtikel';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fibu_nebenkosten_artikel/';
        this.tableDescriptor.route = '/finanzen/nebenkosten-artikel/';
        this.tableDescriptor.nameOfIdField = 'artikel_id';
        this.tableDescriptor.searchPlaceholder = 'Bezeichnung, Konto, Kürzel oder Tags suchen';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openCreateDialog.bind(this);
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openTagsDialog.bind(this);
        this.tableDescriptor.permissionView = 1001;
        this.tableDescriptor.permissionCreate = 1001;
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.defaultPageSize = 50;
        // Filter steckt bereits in der API (nebenkosten=1, honorar=0)
        this.tableDescriptor.params = new HttpParams();

        this.tableDescriptor.columns = [
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('buchungskonto', 'Konto'),
            new TableColumn('kuerzel', 'Kürzel'),
            new TableColumn('tags', 'Tags'),
            new TableColumn('warengruppe', 'Warengruppe'),
            new TableColumn('artikel_id', 'ID'),
        ];

        this.tableDescriptor.options.push(
            new TableOption(this.openTagsDialog.bind(this), 'Tags bearbeiten', 'sell', 1001),
            new TableOption(this.openArtikel.bind(this), 'Im Lager öffnen', 'open_in_new', 1001),
        );
    }

    openCreateDialog() {
        const dialogRef = this.dialog.open(NebenkostenArtikelDialogComponent, {
            width: '520px',
            data: {},
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    openTagsDialog(row: {
        artikel_id?: number;
        bezeichnung?: string;
        kuerzel?: string;
        buchungskonto?: string;
        tags?: string;
    }) {
        if (!row?.artikel_id) {
            return;
        }
        const dialogRef = this.dialog.open(NebenkostenArtikelTagsDialogComponent, {
            width: '560px',
            data: {
                artikel_id: row.artikel_id,
                bezeichnung: row.bezeichnung,
                kuerzel: row.kuerzel,
                buchungskonto: row.buchungskonto,
                tags: row.tags,
            },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    openArtikel(row: { artikel_id?: number }) {
        if (row?.artikel_id) {
            this.router.navigate(['/lager/artikel', row.artikel_id]);
        }
    }
}
